import { IAPiState } from "./reducers/api.reducers";
import { IAuthState } from "./reducers/auth.reducers";
import { IConfig } from "./reducers/config.reducers";
import { IPromotion } from "./reducers/promotion.reducers";
import { IShipmentTypes } from "./reducers/shipmentServices.reducers";
import { IUsers } from "./reducers/users.reducers";
import { IBundlePromotion } from './reducers/bundlePromotion.reducers'
import { IBulkBundlePromotion } from "./reducers/bulkBundleUtility.reducers";
import { IPayments } from "./reducers/paymentMethods.reducers";

export enum EMethods {
  GET = "GET",
  POST = "POST",
  DELETE = "DELETE",
  PUT = "PUT",
  PATCH = "PATCH",
}

export const restrictionNoDisableFields = ["numberOfUsage", "budget"]

export interface IAction<T = any> {
  type: string;
  payload?: T;
}

export type FilterNameType =
  | "startDate"
  | "endDate"
  | "Object"
  | "Status"
  | "type";

export interface IFilterOption {
  name: FilterNameType;
  value: string;
}
export interface IFilter {
  name: FilterNameType;
  value: string[];
}
export interface ISearchQuery {
  searchTerm: string;
  limit?: number;
  page?: number;
}

export type IApiMiddlewareAction = {
  type: string;
  payload: IPayload;
};

export type INetworkRequest = {
  forFileSend?: boolean;
  headers?: object; // Override headers
  method: EMethods;
  url: string;
  data: object;
  isAbsoluteUrl?: boolean;
  isStatic?: boolean;
  withStoreId?: boolean;
  withToken?: boolean;
  requestConfig?: any;
  isBundlePromotion?: boolean;
};

export type IPayload = INetworkRequest & {
  label: string; // Module/feature specific label
  onSuccess?: (data: any) => void;
  onFailure?: (errorMessage: string) => any;
  onFinally?: () => void;
};

export enum EPromotionTypes {
  COUPON = "COUPON",
  DISCOUNT_COUPON = "DISCOUNT_COUPON",
  BIN_CAMPAIGN = "BIN_CAMPAIGN",
  BADGE_CAMPAIGN = "BADGE_CAMPAIGN",
  BULK_COUPON = "BULK_COUPON",
  BMSM_CAMPAIGN = "BMSM_CAMPAIGN",
  SAMPLE_CAMPAIGN = 'SAMPLE_CAMPAIGN',
  BUNDLE_CAMPAIGN = "BUNDLE_CAMPAIGN",
  CREATE_BULK_CAMPAIGN = "CREATE_BULK_CAMPAIGN",
  FEES_WAIVER_CAMPAIGN = "FEES_WAIVER_CAMPAIGN",
  PROMOTION_CALENDAR = "PROMOTION_CALENDAR",
  FREE_GIFT = "FREE_GIFT",
}

export enum EDiscountTypes {
  PERCENTAGE = "PERCENTAGE",
  INCREMENTAL = "INCREMENTAL",
  DISCOUNT = "DISCOUNT",
  FIXED = "FIXED",
  FREE_DELIVERY = 'FREEDELIVERY',
  MILESTONE = "MILESTONE",
}
export interface IControls {
  [key: string]: boolean;
}

export enum ECampaignActions {
  view = "view",
  approve = "approve",
  reject = "reject",
  getReport = "getReport",
  downloadCoupons = "downloadCoupons",
  complete = "complete",
  pause = "pause",
  takeLive = "takeLive",
  fileDownload = "fileDownload",
  viewError = "viewError",
}

export enum ECampaignStatus {
  approved = "approved",
  active = "active",
  paused = "paused",
  completed = "completed",
  expired = "expired",
  pending = "pending",
  created = "created",
  rejected = "rejected",
  creating = "creating",
  processing = "processing",
  processed = "processed",
  validation_failed = "validation_failed",
  archived = "archived",
}
export interface IState {
  api: IAPiState;
  auth: IAuthState;
  config: IConfig;
  promotion: IPromotion;
  users: IUsers;
  shipmentServices: IShipmentTypes;
  bundlePromotion: IBundlePromotion,
  bulkBundlePromotion: IBulkBundlePromotion
  paymentMethods: IPayments,
}
